<template>
  <div>
    <div class="mt-10 library_area mb-10 pb-10">
      <v-text-field
        v-model="searchText"
        outlined
        dense
        label="検索"
        prepend-inner-icon="fas fa-search"
        name="searchText"
        @keyup="keywordSearch()"
      ></v-text-field>
      <v-chip-group active-class="primary--text" style="text-align:center">
        <v-chip
          v-for="(tag, i) in tagMaster"
          :key="i"
          small
          v-model="tagBool[i]"
          @click="tagSearch(tag)"
          >{{ tag.tag }}</v-chip
        >
      </v-chip-group>

      <v-card
        color="light-green lighten-4"
        class="pt-0 pb-0 pr-5 pl-5"
        style="border-radius: 0;"
      >
        <v-row>
          <v-col
            cols="12"
            sm="8"
            class="pt-0 pb-0"
            style="display: table;height: 50px;"
          >
            <span style="vertical-align: middle;display: table-cell;"
              >タイトル</span
            >
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="pl-1 pt-0 pb-0"
            style="display: table;height: 50px;"
          >
            <span style="vertical-align: middle;display: table-cell;"
              >著者</span
            >

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  color="green"
                  style="float: right;"
                  class="mt-2"
                >
                  <v-icon
                    color="#158b2b"
                    small
                    style="transform:rotate(-90deg);"
                    >fas fa-exchange-alt</v-icon
                  >
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(sort, i) in sortMaster"
                  :key="i"
                  @click="sortBook(sort.key)"
                >
                  <v-list-item-title>
                    <v-icon v-if="sortItem===sort.key" color="#158b2b" size="25" class="mr-2 ml-1"
                      >{{sortAsc ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up'}}</v-icon
                    ><v-icon v-else style="opacity: 0;" size="25" class="mr-2 ml-1"
                      >fas fa-long-arrow-alt-down</v-icon
                    >{{ sort.name }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
      <v-row v-if="loading">
        <v-col class="d-flex justify-center">
          <v-progress-circular
            :width="10"
            size="100"
            color="#158b2b"
            indeterminate
          ></v-progress-circular></v-col
      ></v-row>
      <v-expansion-panels multiple :value="openPanels">
        <v-expansion-panel v-for="(item, i) in dispBooks" :key="i">
          <v-expansion-panel-header>
            <v-row>
              <v-col cols="12" sm="8" class="pt-0 pb-1">{{ item.title }}</v-col>
              <v-col cols="12" sm="4" class="pl-5 pt-0 pb-1">{{
                item.writer
              }}</v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" sm="6" class="pt-0">
                <v-row>
                  <v-col cols="12" sm="4" class="pt-2 pb-1 font-weight-bold"
                    >出版社</v-col
                  >
                  <v-col cols="12" sm="8" class="pl-5 pt-2 pb-1">{{
                    item.publication
                  }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" class="pt-2 pb-1 font-weight-bold"
                    >発行日</v-col
                  >
                  <v-col cols="12" sm="8" class="pl-5 pt-2 pb-1">{{
                    item.issueDate
                  }}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" class="pt-2 pb-1 font-weight-bold"
                    >図書コード</v-col
                  >
                  <v-col cols="12" sm="8" class="pl-5 pt-2 pb-1">{{
                    item.bookCd
                  }}</v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="pt-0">
                <div class="file_info_area pl-5 pt-2 pb-2">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="3"
                      class="pt-0 pb-0"
                      style="display: table;height: 40px;"
                    >
                      <span
                        v-if="item.series"
                        style="vertical-align: middle;display: table-cell;"
                        >全{{ item.series }}巻</span
                      >
                    </v-col>
                    <v-col
                      cols="12"
                      sm="9"
                      class="pl-5 pt-0 pb-0"
                      style="display: table;height: 40px;"
                    >
                      <span
                        v-if="item.updateDate"
                        style="vertical-align: middle;display: table-cell;"
                        >{{ item.updateDate }}作成</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-2 pb-1">{{ item.fileFormat }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-2 pb-1">
                      <v-btn
                        v-if="item.file"
                        color="light-green lighten-3"
                        @click="downloadFile(item)"
                      >
                        <v-progress-circular
                          v-if="item.fileDownloading"
                          :width="4"
                          color="#158b2b"
                          size="25"
                          indeterminate
                          class="mr-2"
                        ></v-progress-circular>
                        <v-icon
                          v-else
                          color="#158b2b"
                          size="25"
                          class="mr-2 ml-1"
                          >fas fa-file-download</v-icon
                        >
                        ダウンロード
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" sm="12" class="pt-0">
                <pre style="    white-space: pre-wrap;">{{ item.comment }}</pre>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import firestore from "@/js/firebase";
export default {
  name: "Library",
  data: () => ({
    tagMaster: [
      { tag: "あ行", target: "あいうえお" },
      { tag: "か行", target: "かきくけこがぎぐげご" },
      { tag: "さ行", target: "さしすせそざじずぜぞ" },
      { tag: "た行", target: "たちつてとだぢづでど" },
      { tag: "な行", target: "なにぬねの" },
      { tag: "は行", target: "はひふへほばびぶべぼ" },
      { tag: "ま行", target: "まみむめも" },
      { tag: "や行", target: "やゆよ" },
      { tag: "ら行", target: "らりるれろ" },
      { tag: "わ行", target: "わをん" },
    ],
    sortMaster: [
      { name: "タイトル順", key: "titleKana" },
      { name: "著者名順", key: "writerKana" },
      { name: "公開日順", key: "updateDate" },
    ],
    books: [],
    booksData: [],
    dispBooks: [],
    searchText: "",
    filterTag: "",
    sortItem: "",
    sortAsc: true,
    tagBool: [],
    openPanels: [],
    fileBasePath: "",
    loading: true,
    fileDownloading: false,
  }),
  created() {
    this.get();
  },
  methods: {
    get: function() {
      const s = this;
      firestore
        .collection("books")
        .get()
        .then(function(querySnapshot) {
          s.books = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            data.id = doc.id;
            data.fileDownloading = false;
            s.books.push(data);
          });
          s.getBooks();
        });
    },
    getBooks: function() {
      this.books = this.addTag(this.books);
      this.books = this.addSearchText(this.books);
      this.dispBooks = JSON.parse(JSON.stringify(this.books));
      this.sortBook(this.sortMaster[0].key, true);
      this.loading = false;
    },
    downloadFile: function(book) {
      book.fileDownloading = true;
      const storageRef = firebase.storage().ref();
      const imagesRef = storageRef.child("book");
      const spaceRef = imagesRef.child(book.file);
      spaceRef.getDownloadURL().then(function(url) {
        book.fileDownloading = false;
        window.location.href = url;
      });
    },
    post: function() {
      this.booksData.forEach((element) => {
        firestore.collection("books").add(element);
      });
    },
    keywordSearch() {
      this.openPanels = [];
      const text = this.searchText;
      this.dispBooks = this.books.filter(function(book) {
        return book.searchText.indexOf(text) >= 0;
      });
    },
    tagSearch(tag) {
      this.openPanels = [];
      if (this.filterTag == tag.tag) {
        this.dispBooks = JSON.parse(JSON.stringify(this.books));
        this.filterTag = "";
      } else {
        this.dispBooks = this.books.filter(function(object) {
          return object.tag == tag.tag;
        });
        this.filterTag = tag.tag;
      }
      this.sortBook(this.sortItem, this.sortAsc);
    },
    sortBook(sortKey, asc = !this.sortAsc) {
      this.sortAsc = asc;
      this.openPanels = [];
      this.sortItem = sortKey;
      this.sortDispBooks(sortKey, asc)
    },
    sortDispBooks(key, asc) {
      if (asc) {
        this.dispBooks.sort(function(a, b) {
          if (a[key] < b[key]) return -1;
          if (a[key] > b[key]) return 1;
          return 0;
        });
      }
      else {
        this.dispBooks.sort(function(a, b) {
          if (a[key] > b[key]) return -1;
          if (a[key] < b[key]) return 1;
          return 0;
        });
      }
    },
    addTag(books) {
      books.forEach((book) => {
        if (book.titleKana)
          book.tag = this.cngFirstLetter(book.titleKana.slice(0, 1));
      });
      return books;
    },
    addSearchText(books) {
      books.forEach((book) => {
        book.searchText =
          book.title +
          book.titleKana +
          book.writer +
          book.writerKana +
          book.publication +
          book.bookCd +
          book.comment;
      });
      return books;
    },
    cngFirstLetter(kanaData) {
      var reKey = "";
      this.tagMaster.forEach((item) => {
        if (item.target.indexOf(kanaData) >= 0) {
          reKey = item.tag;
        }
      });
      if (!reKey) reKey = "その他";
      return reKey;
    },
  },
};
</script>

<style scoped>
.library_area {
  margin: auto;
  font-size: 14px;
  max-width: 700px;
}
.file_info_area {
  background-color: #eeeeee;
  border-radius: 1em;
}
.v-expansion-panel-header {
  font-size: 14px;
}
</style>
